import { useState, useRef } from "react";
import { RECOGNITION_ROUNDS, OBJECTS } from "@/data/exercises";
import { Check, X } from "lucide-react";

export default function Recognition({ onComplete }) {
  const [round, setRound] = useState(0);
  const [correct, setCorrect] = useState(0);
  const [picked, setPicked] = useState(null);
  const start = useRef(Date.now());
  const total = RECOGNITION_ROUNDS.length;
  const current = RECOGNITION_ROUNDS[round];

  const pick = (key) => {
    if (picked) return;
    const good = key === current.answer;
    setPicked({ key, good });
    if (good) setCorrect((c) => c + 1);
    setTimeout(() => {
      if (round + 1 >= total) {
        const finalCorrect = correct + (good ? 1 : 0);
        const duration = Math.round((Date.now() - start.current) / 1000);
        const accuracy = Math.round((finalCorrect / total) * 100);
        onComplete({ score: accuracy, accuracy, duration });
      } else {
        setRound((r) => r + 1);
        setPicked(null);
      }
    }, 1000);
  };

  return (
    <div className="w-full max-w-3xl mx-auto text-center" data-testid="recognition-game">
      <p className="text-lg font-care text-emerald-700 font-bold mb-2">
        Image {round + 1} sur {total}
      </p>
      <p className="text-3xl font-patient font-black text-gray-800 mb-10">
        Touchez : <span className="text-emerald-700">{OBJECTS[current.answer].label}</span>
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {current.options.map((key) => {
          const state = picked?.key === key ? (picked.good ? "good" : "bad") : "idle";
          return (
            <button
              key={key}
              onClick={() => pick(key)}
              data-testid={`recognition-option-${key}`}
              className={`relative rounded-3xl border-4 overflow-hidden aspect-square transition-transform duration-200 active:scale-95 ${
                state === "good"
                  ? "border-emerald-600"
                  : state === "bad"
                  ? "border-red-400"
                  : "border-emerald-700/20 hover:border-emerald-500"
              }`}
            >
              <img src={OBJECTS[key].img} alt={OBJECTS[key].label} className="w-full h-full object-cover" />
              {state === "good" && (
                <div className="absolute inset-0 bg-emerald-600/40 flex items-center justify-center">
                  <Check className="w-16 h-16 text-white" strokeWidth={3} />
                </div>
              )}
              {state === "bad" && (
                <div className="absolute inset-0 bg-red-500/30 flex items-center justify-center">
                  <X className="w-16 h-16 text-white" strokeWidth={3} />
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
